module.exports = __webpack_public_path__ + "static/homepage2-c70ad970c8f7445726f240ddf422ea0e.png";